import React, { useState } from 'react';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { ICON_REMOVE, ICON_EDIT, ICON_BRIEFCASE } from '../../../../extras/icons';
import AccusedEditForm from '../../treatment/forms/AccusedEditForm';
import { APROBADA, AGENDADA } from '../../../../../data/audienceStates';
import AccusedDefenseEditForm from '../../treatment/forms/AccusedDefenseEditForm';
//Authorities
import Authorities from '../../../../../services/AuthoritiesService';
import { SOLICITUDES_MODIFICAR } from '../../../../../data/objects';
import { useSelector } from 'react-redux';
import { NOT_AVAILABLE } from '../../../../../constants/messages';
//Función principal
const AccusedInfo = props => {
    //Tomo los props
    const { audience, accused, index } = props;
    //Traigo el store
    const authUser = useSelector(state => state.auth.user);
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state local
    const [showEdit, setShowEdit] = useState(false);
    const [showEditDefense, setShowEditDefense] = useState(false);
    //Manejo la apertura
    const handleOpen = () => {
        setShowEdit(true);
    }
    const handleOpenDefense = () => {
        setShowEditDefense(true);
    }
    //Manejo el cierre
    const handleClose = () => {
        setShowEdit(false);
    }
    const handleCloseDefense = () => {
        setShowEditDefense(false);
    }
    //Analizo si puede editar
    let canEdit = false;
    if(audience.estado && audience.estado.id >= APROBADA && audience.estado.id <= AGENDADA){
        //Verifico permisos
        if(authorities && Authorities.hasPermission(authorities, SOLICITUDES_MODIFICAR)){
            //Puede editar
            canEdit = true;
        }
    }
    //Renderizo
    return (
        <div className="col-12">
            <div className="card mb-2 border-secondary">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <strong className="m-0 font-weight-bold text-dark">IMPUTADO #{ index + 1 }</strong>
                    {
                        canEdit ? (
                            <div className="dropdown no-arrow">
                                <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleOpenDefense}>
                                    <ICON_BRIEFCASE />
                                </Button>

                                <AccusedDefenseEditForm
                                    show={showEditDefense}
                                    handleClose={handleCloseDefense}
                                    audience={audience}
                                    accused={accused}
                                />

                                <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleOpen}>
                                    <ICON_EDIT />
                                </Button>

                                <AccusedEditForm
                                    show={showEdit}
                                    handleClose={handleClose}
                                    audience={audience}
                                    accused={accused}
                                />
                            </div>
                        ) : null
                    }
                </div>
                <div className="card-body">
                    <div className="h6 mb-0 font-weight-bold text-gray-800">
                        <div className="row">
                            <div className="col-md-6 mb-1">
                                <small>APELLIDO Y NOMBRE:</small>
                                <br/>
                                { `${accused.persona.apellido}, ${accused.persona.nombre}` }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>TIPO Y NÚMERO DOC.:</small>
                                <br/>
                                {
                                    accused.persona && accused.persona.identificacion ? (
                                        `${accused.persona.tipoDocumento}: ${accused.persona.identificacion}`
                                    ) : NOT_AVAILABLE
                                }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>ES MENOR?:</small>
                                <br/>
                                { accused.menor === 1 ? 'SI' : 'NO' }
                            </div>
                            <div className="col-md-6 mb-1">
                                <small>DOMICILIO:</small>
                                <br/>
                                { accused.domicilio }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>TELÉFONO:</small>
                                <br/>
                                { accused.telefono }
                            </div>
                            <div className="col-md-3 mb-1">
                                <small>EMAIL:</small>
                                <br/>
                                {
                                    accused.persona.identificacion ? (
                                        accused.email
                                    ) : NOT_AVAILABLE
                                }
                            </div>
                            
                            <div className="col-md-6 mb-1">
                                <small>DEF. MENORES:</small>
                                <br/>
                                {
                                    accused.menores ? accused.menores.descripcion : 'N/D'
                                }
                            </div>
                            <div className="col-md-6 mb-1">
                                <small>DEFENSA PÚBLICA:</small>
                                <br/>
                                {
                                    accused.defensoria ? accused.defensoria.descripcion : 'N/D'
                                }
                            </div>
                            {
                                accused.imputadoParticularesList && accused.imputadoParticularesList.length > 0 ? (
                                    <div className="col-12 mb-1 mt-1">
                                        <table className="table table-bordered table-sm">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th colSpan="3" className="align-middle text-center">
                                                        DEFENSORES PARTICULARES
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th className="text-center">Apellido y Nombre</th>
                                                    <th className="text-center">Email</th>
                                                    <th className="text-center">Teléfono</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    accused.imputadoParticularesList.map(particular => (
                                                        <tr key={`aiap${particular.id}`}>
                                                            <td>{ `${particular.persona.apellido}, ${particular.persona.nombre}` }</td>
                                                            <td className="text-center">{ particular.email }</td>
                                                            <td className="text-center">{ particular.telefono }</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                ) : null
                            }
                            <div className="col-md-2 mb-1">
                                <small>DETENIDO?:</small>
                                <br/>
                                { accused.detenido === 1 ? 'SI' : 'NO' }
                            </div>
                            {
                                accused.detenido === 1 ? (
                                    <React.Fragment>
                                        <div className="col-md-6 mb-1">
                                            <small>DEPENDENCIA:</small>
                                            <br/>
                                            { accused.dependencia ? accused.dependencia.descripcion : 'N/D' }
                                        </div>
                                        <div className="col-md-2 mb-1">
                                            <small>DETENCIÓN:</small>
                                            <br/>
                                            { accused.fechaDetencion ? moment(accused.fechaDetencion).format('DD/MM/YYYY HH:mm') : '' }
                                        </div>
                                        <div className="col-md-2 mb-1">
                                            <small>VENCIMIENTO:</small>
                                            <br/>
                                            <span className="text-danger">
                                            { accused.fechaVencimiento ? moment(accused.fechaVencimiento).format('DD/MM/YYYY HH:mm') : '' }
                                            </span>
                                        </div>
                                    </React.Fragment>
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccusedInfo;